/* src/app/components/payroll/timesheets/timesheet-billing-adjustment/timesheet-billing-adjustment.component.css */
.table-style {
  width: 100%;
}
.error-message1 {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
}
/*# sourceMappingURL=timesheet-billing-adjustment.component-WYZEURVM.css.map */
